var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5671_22905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C13 0.2 10.5 1.1 8.59999 2.4C6.49999 1.4 3.99999 1.8 2.29999 3.6C1.99999 3.9 1.69999 4.3 1.39999 4.7L3.89999 7.2C3.19999 8.4 2.79999 9.2 2.79999 9.2L6.89999 13.3C6.89999 13.3 7.69999 13 8.89999 12.2L11.4 14.7C11.8 14.5 12.2 14.2 12.5 13.8C14.2 12.1 14.6 9.5 13.7 7.4C14.9 5.4 15.8 3 16 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600005 12.6C1.40001 11.8 2.60001 11.8 3.40001 12.6C4.20001 13.4 4.20001 14.6 3.40001 15.4C2.60001 16.2 5.42216e-06 16 5.42216e-06 16C5.42216e-06 16 -0.199995 13.3 0.600005 12.6Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5671_22905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.236a73741fe6930ee4df682879e11a60.svg";
export { ForwardRef as ReactComponent };